import { render, staticRenderFns } from "./menuCatalogManage.vue?vue&type=template&id=0ec1a05a&scoped=true"
import script from "./menuCatalogManage.vue?vue&type=script&lang=js"
export * from "./menuCatalogManage.vue?vue&type=script&lang=js"
import style0 from "./menuCatalogManage.vue?vue&type=style&index=0&id=0ec1a05a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec1a05a",
  null
  
)

export default component.exports